import { render, staticRenderFns } from "./Eventos.vue?vue&type=template&id=e9d8bb3a"
import script from "./Eventos.vue?vue&type=script&lang=ts"
export * from "./Eventos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports